import { DateTime } from 'luxon';
import { displayMessage } from '../../../services/helper';

export default

    [
        {
            field: 'monitor',
            headerName: displayMessage('MONITOR'),
            width: 150,
            valueGetter: function (params) {
                return `${params.row?.Monitor?.first_name || ''} ${params.row?.Monitor?.last_name || ''}`
            }
        },
        {
            field: "event_type_description",
            headerName: displayMessage('EVENT_TYPE'),
            flex: 1,
            align: 'left',
            type: 'text'
        },
        {
            field: 'createdAt',
            type: 'date',
            headerName: displayMessage('EVENT_DATE'),
            width: 220,
            valueFormatter: (params) => {
                if (!params?.value) {
                    return params?.value
                }
                const data = DateTime.fromISO(params.value, { zone: 'local' });
                return data.toFormat('dd/MM/yyyy HH:mm:ss')
            }
        }

    ]